export function formatRelativeFreshness(dateValue) {
  if (!dateValue) return "—";
  const then = new Date(dateValue).getTime();
  if (Number.isNaN(then)) return "—";

  const diffMs = Date.now() - then;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins} min ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7) return `${diffDays} days ago`;
  return new Date(dateValue).toLocaleDateString();
}

export function formatUnitPrice(amount, unit) {
  if (amount == null) return "—";
  const formatted = `COP ${Math.round(Number(amount)).toLocaleString("es-CO")}`;
  return unit ? `${formatted} / ${unit}` : formatted;
}

export function statusBadgeClass(status) {
  const key = String(status || "").toLowerCase().replace(/_/g, "-");
  return `food-status-badge food-status-badge--${key}`;
}
